module.exports = [{"id":0,"music":"./static/sample/grandfathers_clock/music.mp3","project":"./static/sample/grandfathers_clock/project.pxbp","jacket":"./static/sample/grandfathers_clock/jacket.png"},{"id":1,"music":"./static/sample/GGAM/music.mp3","project":"./static/sample/GGAM/project.pxbp"}]


//////////////////
// WEBPACK FOOTER
// ./static/sample/sample-music-list.json
// module id = cPLG
// module chunks = 1